class LiveCharacterCounter {
    public static initializeCounters(): LiveCharacterCounter[] {
        const instances: LiveCharacterCounter[] = []

        for (const characterCountElement of document.querySelectorAll(
            ".live-character-count",
        ) as NodeListOf<HTMLElement>) {
            const referenceElementId: string = characterCountElement.dataset.for || ""

            if ("initialized" in characterCountElement.dataset || referenceElementId === "") {
                continue
            }

            const counterElement: HTMLInputElement | HTMLTextAreaElement | null = document.getElementById(
                referenceElementId,
            ) as HTMLInputElement | HTMLTextAreaElement | null

            if (!counterElement) {
                continue
            }

            instances.push(new LiveCharacterCounter(counterElement, characterCountElement))
        }

        return instances
    }

    private constructor(
        private counterSource: HTMLInputElement | HTMLTextAreaElement,
        private counterDisplay: HTMLElement,
    ) {
        this.counterSource.addEventListener("input", (): void => this.updateCounterDisplay(), { passive: true })
        this.counterSource.dataset.initialized = ""
    }

    private updateCounterDisplay(): void {
        requestAnimationFrame(() => {
            this.counterDisplay.textContent = this.counterSource.value.length.toString()
        })
    }
}

export const updateCharacterCounters = LiveCharacterCounter.initializeCounters

LiveCharacterCounter.initializeCounters()
